import script from "./RetoursPatientsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RetoursPatientsView.vue?vue&type=script&setup=true&lang=ts"

import "./RetoursPatientsView.vue?vue&type=style&index=0&id=fbe22000&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbe22000"]])

export default __exports__